var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-content"},[(_vm.pageContent)?_c('RichContent',{attrs:{"content":_vm.pageContent}}):_c('p',[_vm._v("This department doesn’t have a description yet")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }